import {
  formatDate,
  getCalendarDate,
  getCurrentCalendarDate,
  getEndOfDate,
  getEndOfPreviousDate,
  isValidDate
} from "./chunk.HLRT5FOM.js";
import {
  DateTime
} from "./chunk.JAWPSPJ3.js";
import {
  calendar_styles_default
} from "./chunk.HCHFDW4S.js";
import {
  dateAttributeConverter
} from "./chunk.MIOPVZYG.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/calendar/calendar.ts
import { t as t2 } from "i18next";
var id = 0;
var FadvCalendar = class extends s {
  constructor() {
    super(...arguments);
    this.componentId = `date-picker-${++id}`;
    this.currentDate = getCurrentCalendarDate();
    this.mode = "date";
    this.rangeMode = "from";
    this.firstRender = true;
  }
  get state() {
    return {
      isRange: !!this.range,
      currentDate: this.currentDate,
      workingDate: this.workingDate,
      minDate: getEndOfPreviousDate(this.minDate),
      maxDate: getEndOfDate(this.maxDate),
      selectedDate: this.date ? getCalendarDate(this.date) : void 0,
      rangeStart: this.rangeStart ? getCalendarDate(this.rangeStart) : void 0,
      rangeEnd: this.rangeEnd ? getCalendarDate(this.rangeEnd) : void 0
    };
  }
  initialize() {
    if (this.date && !this.workingDate) {
      this.workingDate = new Date(this.date);
    }
    if (!this.workingDate) {
      if (this.minDate && this.minDate > this.currentDate) {
        this.workingDate = this.minDate;
      } else if (this.maxDate && this.maxDate < this.currentDate) {
        this.workingDate = this.maxDate;
      } else {
        this.workingDate = new Date((this.range ? this.rangeStart : this.date) || this.currentDate);
      }
    }
    if (!this.picker || this.mode !== this.picker.mode) {
      this.createPicker();
    } else {
      this.picker.state = this.state;
    }
  }
  handleRangeChange() {
    if (this.range) {
      this.date = void 0;
    } else {
      this.rangeStart = void 0;
      this.rangeEnd = void 0;
    }
  }
  navigateToDate() {
    if (this.date && isValidDate(this.date)) {
      this.updateWorkingDate(getCalendarDate(this.date));
    }
  }
  navigateToRangeStart(oldValue, newValue) {
    if (!this.range)
      return;
    if ((oldValue == null ? void 0 : oldValue.getTime()) === (newValue == null ? void 0 : newValue.getTime()))
      return;
    if (this.rangeStart && isValidDate(this.rangeStart)) {
      this.updateWorkingDate(getCalendarDate(this.rangeStart));
      this.rangeMode = "from";
    }
  }
  navigateToRangeEnd(oldValue, newValue) {
    if (!this.range)
      return;
    if ((oldValue == null ? void 0 : oldValue.getTime()) === (newValue == null ? void 0 : newValue.getTime()))
      return;
    if (this.rangeEnd && isValidDate(this.rangeEnd)) {
      this.updateWorkingDate(getCalendarDate(this.rangeEnd));
      this.rangeMode = "to";
    }
  }
  createPicker() {
    this.picker = document.createElement(`fadv-calendar-${this.mode}-picker`);
    this.picker.state = this.state;
    if (!this.firstRender) {
      requestAnimationFrame(() => {
        this.picker.focus();
      });
    } else {
      this.firstRender = false;
    }
  }
  handleDateChange(e2) {
    this.workingDate = new Date(e2.detail.date);
    this.mode = e2.detail.mode || this.mode;
    if (!e2.detail.selectDate)
      return;
    if (this.state.minDate && e2.detail.date < this.state.minDate)
      return;
    if (this.state.maxDate && e2.detail.date >= this.state.maxDate)
      return;
    if (this.range) {
      this.selectRangeDate();
    } else {
      this.selectSingleDate();
    }
  }
  selectSingleDate() {
    this.date = new Date(this.workingDate);
    emit(this, "fadv-calendar-date-change", { detail: { date: this.date } });
  }
  selectRangeDate() {
    if (!this.rangeStart && !this.rangeEnd) {
      this.rangeStart = new Date(this.workingDate);
      this.rangeEnd = void 0;
      this.rangeMode = "to";
    } else if (this.rangeStart && !this.rangeEnd) {
      this.rangeEnd = new Date(this.workingDate);
    } else if (this.rangeStart && this.rangeEnd) {
      this.rangeStart = new Date(this.workingDate);
      this.rangeEnd = void 0;
    }
    if (this.rangeStart && this.rangeEnd && this.rangeStart > this.rangeEnd) {
      const end = this.rangeStart;
      this.rangeStart = new Date(this.rangeEnd);
      this.rangeEnd = new Date(end);
    }
    emit(this, "fadv-calendar-range-change", { detail: { rangeStart: this.rangeStart, rangeEnd: this.rangeEnd } });
  }
  handleModeChange() {
    switch (this.mode) {
      case "date":
        this.mode = "year";
        break;
      case "month":
        this.mode = "year";
        break;
      case "year":
        this.mode = "date";
        break;
    }
  }
  focus(options) {
    var _a;
    (_a = this.picker) == null ? void 0 : _a.focus(options);
  }
  updateWorkingDate(date) {
    this.handleDateChange(new CustomEvent("fadv-date-changed", { detail: { date, mode: "date", selectDate: false } }));
  }
  getFormattedDate(date) {
    if (!date)
      return "";
    if (this.datePattern)
      return DateTime.fromJSDate(date).toFormat(this.datePattern);
    return formatDate(date);
  }
  render() {
    this.initialize();
    return $`<div id=${this.componentId} role="dialog" class=${o({
      calendar: true,
      "calendar--range": !!this.range
    })} @fadv-cal-nav-mode-change=${this.handleModeChange} ><div class="calendar__display"><div class=${o({
      "calendar__display-item": true,
      "calendar__display-item-visible": !!this.range,
      "calendar__display-item-active": !!this.range && this.rangeMode === "from"
    })} @click=${() => this.navigateToRangeStart(this.workingDate, this.rangeStart)} ><fadv-typography weight="500" type="label-medium">${isValidDate(this.rangeStart) ? this.getFormattedDate(this.rangeStart) : t2("components:calendar.from")}</fadv-typography></div><div class=${o({
      "calendar__display-item": true,
      "calendar__display-item-visible": !!this.range,
      "calendar__display-item-active": !!this.range && this.rangeMode === "to"
    })} @click=${() => this.navigateToRangeEnd(this.workingDate, this.rangeEnd)} ><fadv-typography weight="500" type="label-medium">${isValidDate(this.rangeEnd) ? this.getFormattedDate(this.rangeEnd) : t2("components:calendar.to")}</fadv-typography></div><div class=${o({
      "calendar__display-item": true,
      "calendar__display-item-visible": !this.range,
      "calendar__display-item-active": isValidDate(this.date)
    })} @click=${() => this.navigateToDate()} ><fadv-typography weight="500" type="label-medium">${isValidDate(this.date) ? this.getFormattedDate(this.date) : t2("components:calendar.select")}</fadv-typography></div></div><div @fadv-date-changed=${this.handleDateChange} class="calendar__picker">${this.picker}</div></div>`;
  }
};
FadvCalendar.styles = calendar_styles_default;
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvCalendar.prototype, "range", 2);
__decorateClass([
  e({ reflect: true, converter: dateAttributeConverter })
], FadvCalendar.prototype, "date", 2);
__decorateClass([
  e({ reflect: true, converter: dateAttributeConverter, attribute: "range-start" })
], FadvCalendar.prototype, "rangeStart", 2);
__decorateClass([
  e({ reflect: true, converter: dateAttributeConverter, attribute: "range-end" })
], FadvCalendar.prototype, "rangeEnd", 2);
__decorateClass([
  e({ reflect: true, converter: dateAttributeConverter, attribute: "min-date" })
], FadvCalendar.prototype, "minDate", 2);
__decorateClass([
  e({ reflect: true, converter: dateAttributeConverter, attribute: "max-date" })
], FadvCalendar.prototype, "maxDate", 2);
__decorateClass([
  e({ attribute: "date-pattern" })
], FadvCalendar.prototype, "datePattern", 2);
__decorateClass([
  t()
], FadvCalendar.prototype, "workingDate", 2);
__decorateClass([
  t()
], FadvCalendar.prototype, "currentDate", 2);
__decorateClass([
  t()
], FadvCalendar.prototype, "mode", 2);
__decorateClass([
  t()
], FadvCalendar.prototype, "rangeMode", 2);
__decorateClass([
  t()
], FadvCalendar.prototype, "firstRender", 2);
__decorateClass([
  watch("range")
], FadvCalendar.prototype, "handleRangeChange", 1);
__decorateClass([
  watch("date")
], FadvCalendar.prototype, "navigateToDate", 1);
__decorateClass([
  watch("rangeStart")
], FadvCalendar.prototype, "navigateToRangeStart", 1);
__decorateClass([
  watch("rangeEnd")
], FadvCalendar.prototype, "navigateToRangeEnd", 1);
FadvCalendar = __decorateClass([
  n("fadv-calendar")
], FadvCalendar);

export {
  FadvCalendar
};
